import {
  ChartBarIcon,
  CogIcon,
  InformationCircleIcon,
} from '@heroicons/react/outline'

import { GAME_TITLE } from '../../constants/strings'

type Props = {
  setIsInfoModalOpen: (value: boolean) => void
  setIsStatsModalOpen: (value: boolean) => void
  setIsSettingsModalOpen: (value: boolean) => void
  theme: string
}

export const Navbar = ({
  setIsInfoModalOpen,
  setIsStatsModalOpen,
  setIsSettingsModalOpen,
  theme,
}: Props) => {
  const getNavbarIconsClass = () => {
    switch (theme) {
      case 'colorful':
        return 'stroke-[#87CEEB]'
      default:
        return ''
    }
  }

  const getNavbarGameTitleClass = () => {
    switch (theme) {
      case 'colorful':
        return 'text-[#87CEEB]'
      default:
        return ''
    }
  }

  return (
    <div className="navbar">
      <div className="navbar-content px-5 short:h-auto">
        <div className="flex">
          <InformationCircleIcon
            className={`h-6 w-6 cursor-pointer dark:stroke-white ${getNavbarIconsClass()}`}
            onClick={() => setIsInfoModalOpen(true)}
          />
        </div>
        <p
          className={`text-xl font-bold dark:text-white ${getNavbarGameTitleClass()}`}
        >
          {GAME_TITLE}
        </p>
        <div className="right-icons">
          <ChartBarIcon
            className={`mr-3 h-6 w-6 cursor-pointer dark:stroke-white ${getNavbarIconsClass()}`}
            onClick={() => setIsStatsModalOpen(true)}
          />
          <CogIcon
            className={`h-6 w-6 cursor-pointer dark:stroke-white ${getNavbarIconsClass()}`}
            onClick={() => setIsSettingsModalOpen(true)}
          />
        </div>
      </div>
      <hr></hr>
    </div>
  )
}
